export default __webpack_public_path__ + "static/media/Memoria-anual-2019-para-pantalla.5e82b78e.webp";